module.exports = __webpack_public_path__ + "media/47.2ab08b08.mp3";